<ngx-one-column-layout class="app-view">
  <nb-menu [items]="menu"></nb-menu>
  <ngx-chat-app
    (onClose)="closeChatApp()"
    *ngIf="isChatActive | async"
  ></ngx-chat-app>
  <router-outlet></router-outlet>
</ngx-one-column-layout>
